import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { TreatmentProgramResponse } from 'generated/index';

import type { GridColDef } from '@mui/x-data-grid-pro';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

export const useColumnDefinitions = () => {
  const { t } = useTranslation('common');
  return useMemo<GridColDef<TreatmentProgramResponse>[]>(
    () => [
      {
        field: 'externalId',
        headerName: t('adminPortal.treatmentPrograms.externalId'),
        hideable: false,
        minWidth: 120
      },
      {
        field: 'name',
        headerName: t('adminPortal.treatmentPrograms.name'),
        hideable: false,
        flex: 1
      },
      {
        field: 'plannable',
        headerName: t('adminPortal.treatmentPrograms.plannable'),
        type: 'boolean',
        hideable: false,
        minWidth: 120,
        renderCell: BooleanCell
      }
    ],
    [t]
  );
};
